// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';

// // Define the file type
// export interface FileData {
//   file_name: string;
//   blob_path: string;
//   sas_url: string;
// }

// // Define the form data type
// // Define the form data type
// export interface OrganizationFormData {
//   business_name: string;
//   abn: string;
//   bsb: string;
//   account_number: string;
//   account_name: string;
//   business_email: string;
//   smtp_server: string;
//   smtp_port: string;
//   smtp_username: string;
//   smtp_password: string;
//   business_phone: string;
//   business_address: string;
//   state: string;
//   website?: string;
//   logo?: File;
//   support_items_file?: File;
//   Gst_code: string;
//   In_kind_finding_program: string;
//   registration_number: string;
//   Participant_approved: boolean;
// }

// // Define the organization interface for view mode
// export interface Organization {
//   id?: string;
//   business_name: string;
//   abn: string;
//   bsb: string;
//   account_number: string;
//   account_name: string;
//   business_email: string;
//   smtp_server: string;
//   smtp_port: string;
//   smtp_username: string;
//   smtp_password: string;
//   business_phone: string;
//   business_address: string;
//   state: string;
//   website?: string;
//   icon_path?: string;
//   excel_path?: string;
//   files?: FileData[];
//   created_by?: string;
//   created_at?: string;
//   Gst_code: string;
//   In_kind_finding_program: string;
//   registration_number: string;
//   Participant_approved: boolean;
// }
// // Define the state type
// export interface OrganizationState {
//   organization: Organization | null;
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: OrganizationState = {
//   organization: null,
//   loading: false,
//   message: null,
//   error: null
// };

// // Async thunk for fetching organization
// export const fetchOrganization = createAsyncThunk<
//   Organization,
//   { group_id: string; service_name_id: string },
//   { rejectValue: string }
// >('organization/fetchOrganization', async ({ group_id, service_name_id }, { rejectWithValue }) => {
//   try {
//     const payload = {
//       group_id,
//       service_name_id
//     };

//     const response = await axiosInstance.post('/ndis/corporate-services/get-org', payload);
//     const { org_data, files } = response.data;
//     return { ...org_data, files };
//   } catch (error: any) {
//     return rejectWithValue(error.response?.data?.message || 'Failed to fetch organization data');
//   }
// });

// // Async thunk for creating organization
// export const createOrganization = createAsyncThunk<
//   { message: string },
//   OrganizationFormData,
//   { rejectValue: string }
// >('organization/createOrganization', async (formData, { rejectWithValue }) => {
//   try {
//     // Retrieve group_id and service_name_id from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };

//     const group_id = project.projectId || '';
//     const service_name_id = service.selectedServiceTitle || '';

//     if (!group_id || !service_name_id) {
//       return rejectWithValue('Missing group_id or service_name_id in localStorage');
//     }

//     // Convert logo to base64 if present
//     let logoBase64: string | undefined;
//     if (formData.logo) {
//       const reader = new FileReader();
//       logoBase64 = await new Promise((resolve) => {
//         reader.onload = () => resolve((reader.result as string).split(',')[1]); // Remove data URL prefix
//         reader.readAsDataURL(formData.logo!);
//       });
//     }

//     // Create JSON payload with icon_path as base64
//     const jsonPayload = {
//       group_id,
//       service_name_id,
//       business_name: formData.business_name,
//       abn: formData.abn,
//       business_address: formData.business_address,
//       state: formData.state,
//       website: formData.website || '',
//       business_phone: formData.business_phone,
//       business_email: formData.business_email,
//       smtp_server: formData.smtp_server,
//       smtp_port: formData.smtp_port,
//       smtp_username: formData.smtp_username,
//       smtp_password: formData.smtp_password,
//       bsb: formData.bsb,
//       account_number: formData.account_number,
//       account_name: formData.account_name,
//       icon_path: logoBase64
//     };

//     // Create FormData object for multipart/form-data
//     const formDataPayload = new FormData();
//     formDataPayload.append('json', JSON.stringify(jsonPayload));
//     if (formData.support_items_file) {
//       formDataPayload.append('excel', formData.support_items_file);
//     }

//     const response = await axiosInstance.post(
//       '/ndis/corporate-services/create-org',
//       formDataPayload,
//       {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       }
//     );

//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(error.response?.data?.error || 'Failed to create organization');
//   }
// });

// const organizationSlice = createSlice({
//   name: 'organization',
//   initialState,
//   reducers: {
//     clearOrganizationState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchOrganization.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(fetchOrganization.fulfilled, (state, action) => {
//         state.loading = false;
//         state.organization = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchOrganization.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//       })
//       .addCase(createOrganization.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(createOrganization.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Organization created successfully';
//         state.error = null;
//       })
//       .addCase(createOrganization.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearOrganizationState } = organizationSlice.actions;
// export default organizationSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';

// Define the file type
export interface FileData {
  file_name: string;
  blob_path: string;
  sas_url: string;
}

// Define the form data type
export interface OrganizationFormData {
  business_name: string;
  abn: string;
  bsb: string;
  account_number: string;
  account_name: string;
  business_email: string;
  smtp_server: string;
  smtp_port: string;
  smtp_username: string;
  smtp_password: string;
  business_phone: string;
  business_address: string;
  state: string;
  website?: string;
  logo?: File;
  support_items_file?: File;
  Gst_code: string;
  In_kind_finding_program: string;
  registration_number: string;
  Participant_approved: boolean;
}

// Define the organization interface for view mode
export interface Organization {
  id?: string;
  business_name: string;
  abn: string;
  bsb: string;
  account_number: string;
  account_name: string;
  business_email: string;
  smtp_server: string;
  smtp_port: string;
  smtp_username: string;
  smtp_password: string;
  business_phone: string;
  business_address: string;
  state: string;
  website?: string;
  icon_path?: string;
  excel_path?: string;
  files?: FileData[];
  created_by?: string;
  created_at?: string;
  Gst_code: string;
  In_kind_finding_program: string;
  registration_number: string;
  Participant_approved: boolean;
}

// Define the state type
export interface OrganizationState {
  organization: Organization | null;
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: OrganizationState = {
  organization: null,
  loading: false,
  message: null,
  error: null
};

// Async thunk for fetching organization
export const fetchOrganization = createAsyncThunk<
  Organization,
  { group_id: string; service_name_id: string },
  { rejectValue: string }
>('organization/fetchOrganization', async ({ group_id, service_name_id }, { rejectWithValue }) => {
  try {
    const payload = {
      group_id,
      service_name_id
    };

    const response = await axiosInstance.post('/ndis/corporate-services/get-org', payload);
    const { org_data, files } = response.data;
    return { ...org_data, files };
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch organization data');
  }
});

// Async thunk for creating organization
export const createOrganization = createAsyncThunk<
  { message: string },
  OrganizationFormData,
  { rejectValue: string }
>('organization/createOrganization', async (formData, { rejectWithValue }) => {
  try {
    // Retrieve group_id and service_name_id from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };

    const group_id = project.projectId || '';
    const service_name_id = service.selectedServiceTitle || '';

    if (!group_id || !service_name_id) {
      return rejectWithValue('Missing group_id or service_name_id in localStorage');
    }

    // Convert logo to base64 if present
    let logoBase64: string | undefined;
    if (formData.logo) {
      const reader = new FileReader();
      logoBase64 = await new Promise((resolve) => {
        reader.onload = () => resolve((reader.result as string).split(',')[1]); // Remove data URL prefix
        reader.readAsDataURL(formData.logo!);
      });
    }

    // Create JSON payload with all fields
    const jsonPayload = {
      group_id,
      service_name_id,
      business_name: formData.business_name,
      abn: formData.abn,
      business_address: formData.business_address,
      state: formData.state,
      website: formData.website || '',
      business_phone: formData.business_phone,
      business_email: formData.business_email,
      smtp_server: formData.smtp_server,
      smtp_port: formData.smtp_port,
      smtp_username: formData.smtp_username,
      smtp_password: formData.smtp_password,
      bsb: formData.bsb,
      account_number: formData.account_number,
      account_name: formData.account_name,
      icon_path: logoBase64,
      Gst_code: formData.Gst_code,
      In_kind_finding_program: formData.In_kind_finding_program,
      registration_number: formData.registration_number,
      Participant_approved: formData.Participant_approved
    };

    // Create FormData object for multipart/form-data
    const formDataPayload = new FormData();
    formDataPayload.append('json', JSON.stringify(jsonPayload));
    if (formData.support_items_file) {
      formDataPayload.append('excel', formData.support_items_file);
    }

    const response = await axiosInstance.post(
      '/ndis/corporate-services/create-org',
      formDataPayload,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.error || 'Failed to create organization');
  }
});

// Async thunk for updating organization
export const updateOrganization = createAsyncThunk<
  { message: string },
  OrganizationFormData,
  { rejectValue: string }
>('organization/updateOrganization', async (formData, { rejectWithValue }) => {
  try {
    // Retrieve group_id and service_name_id from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };

    const group_id = project.projectId || '';
    const service_name_id = service.selectedServiceTitle || '';

    if (!group_id || !service_name_id) {
      return rejectWithValue('Missing group_id or service_name_id in localStorage');
    }

    // Convert logo to base64 if present
    let logoBase64: string | undefined;
    if (formData.logo) {
      const reader = new FileReader();
      logoBase64 = await new Promise((resolve) => {
        reader.onload = () => resolve((reader.result as string).split(',')[1]);
        reader.readAsDataURL(formData.logo!);
      });
    }

    // Create JSON payload with all fields
    const jsonPayload = {
      group_id,
      service_name_id,
      business_name: formData.business_name,
      abn: formData.abn,
      business_address: formData.business_address,
      state: formData.state,
      website: formData.website || '',
      business_phone: formData.business_phone,
      business_email: formData.business_email,
      smtp_server: formData.smtp_server,
      smtp_port: formData.smtp_port,
      smtp_username: formData.smtp_username,
      smtp_password: formData.smtp_password,
      bsb: formData.bsb,
      account_number: formData.account_number,
      account_name: formData.account_name,
      icon_path: logoBase64,
      Gst_code: formData.Gst_code,
      In_kind_finding_program: formData.In_kind_finding_program,
      registration_number: formData.registration_number,
      Participant_approved: formData.Participant_approved
    };

    // Create FormData object for multipart/form-data
    const formDataPayload = new FormData();
    formDataPayload.append('json', JSON.stringify(jsonPayload));
    if (formData.support_items_file) {
      formDataPayload.append('excel', formData.support_items_file);
    }

    const response = await axiosInstance.patch(
      '/ndis/corporate-services/update-org',
      formDataPayload,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.error || 'Failed to update organization');
  }
});

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    clearOrganizationState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganization.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(fetchOrganization.fulfilled, (state, action) => {
        state.loading = false;
        state.organization = action.payload;
        state.error = null;
      })
      .addCase(fetchOrganization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(createOrganization.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(createOrganization.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Organization created successfully';
        state.error = null;
      })
      .addCase(createOrganization.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      })
      .addCase(updateOrganization.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(updateOrganization.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Organization updated successfully';
        state.error = null;
      })
      .addCase(updateOrganization.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearOrganizationState } = organizationSlice.actions;
export default organizationSlice.reducer;